import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Page from 'assets/components/page/Page';
import ThemePageCentered from 'assets/components/page/themes/Theme.Page.Centered';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ThemeWrapperSteps from 'assets/themes/wrappers/Theme.Wrapper.Steps';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import useSalesQuote, { SalesQuoteAction } from './Sales.Quote.Hooks';
import SalesQuoteProducts from './sections/Sales.Quote.Products';
import SalesQuoteQuote from './sections/Sales.Quote.Quote';
import SalesQuoteVehicle from './sections/Sales.Quote.Vehicle';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import Box from 'assets/components/box/Box';

export const salesQuoteIndexRoute = salesHomeRoute + '/quote/:action/:id?';
export default function SalesQuoteIndex() {
  const { lang } = getLocales();
  const newQuoteHook = useSalesQuote();

  if (!newQuoteHook.isAllowed) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={newQuoteHook}
        render={({ isAllowed, activeTab, nextTab, next, prev, reset, openTab, prevTab, permissions, form, tabs }) => (
          <Page
            class={ThemePageCentered}
            header={<h2>{lang.quote}</h2>}
            subHeader={
              <div className={ThemeWrapperSteps}>
                <DataMap
                  data={tabs}
                  render={({ data: tab }) => (
                    <div
                      id={tab.id}
                      data-active={tab.id === activeTab.id ? true : undefined}
                      style={{ cursor: form.data.id ? 'pointer' : undefined }}
                      onClick={
                        form.data.id && !tab.hasErrors && tab.id !== SalesQuoteAction.QUOTE
                          ? () => openTab(tab.id)
                          : null
                      }
                    >
                      {tab.label}
                    </div>
                  )}
                />
              </div>
            }
            render={
              isAllowed ? (
                <>
                  {activeTab.id === SalesQuoteAction.VEHICLE && <SalesQuoteVehicle />}
                  {activeTab.id === SalesQuoteAction.PRODUCTS && <SalesQuoteProducts />}
                  {activeTab.id === SalesQuoteAction.QUOTE && <SalesQuoteQuote />}
                </>
              ) : (
                <ErrorPage status={HttpStatus.unauthorized} />
              )
            }
            footer={
              <Box class={ThemeWrapperStack} style={{ justifyContent: 'flex-end' }}>
                {activeTab.id === SalesQuoteAction.QUOTE ? (
                  <Button
                    class={ThemeButtonCircle}
                    active
                    render={lang.reset}
                    onClick={reset}
                    disabled={!permissions.CREATE_CONTRACT}
                  />
                ) : (
                  <>
                    <Button
                      onClick={prev}
                      render={lang.prev}
                      class={ThemeButtonCircle}
                      active={activeTab.id !== prevTab.id}
                      disabled={activeTab.id === prevTab.id}
                    />
                    <Button
                      onClick={next}
                      render={lang.next}
                      class={ThemeButtonCircle}
                      active={activeTab.id !== nextTab.id}
                      disabled={activeTab.id === nextTab.id || activeTab.hasErrors}
                      isLoading={form.isSubmitted}
                    />
                  </>
                )}
              </Box>
            }
          />
        )}
      />
    </>
  );
}
